import { render, staticRenderFns } from "./ProvisionQuery.vue?vue&type=template&id=99822fca&scoped=true&"
import script from "./ProvisionQuery.vue?vue&type=script&lang=js&"
export * from "./ProvisionQuery.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionQuery.vue?vue&type=style&index=0&id=99822fca&scoped=true&lang=scss&"
import style1 from "./ProvisionQuery.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99822fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99822fca')) {
      api.createRecord('99822fca', component.options)
    } else {
      api.reload('99822fca', component.options)
    }
    module.hot.accept("./ProvisionQuery.vue?vue&type=template&id=99822fca&scoped=true&", function () {
      api.rerender('99822fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/ProvisionQuery.vue"
export default component.exports